<template>
  <div>
    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="d-flex justify-space-between align-center headline white--text">
            <div class="d-flex align-center">
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
              <dialog-new-returned v-if="can_create"></dialog-new-returned>
            </div>
            <span>
              Cheques retornados
            </span>
            <div class="d-flex">
              <BtnCreateDataExport 
                class="mx-3"
                api_model="ReturnedCheck" 
                action="ReturnedChecks"
                :filters="filters"
              ></BtnCreateDataExport>
              <v-btn text icon color="white" aria-label="Atualizar lista" @click="onHeaderRefreshReturnedChecks">
                <v-icon color="white">mdi-refresh</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text>
            <v-tabs icons-and-text grow color="none">
              <v-tabs-slider color="blue-grey"></v-tabs-slider>
              <v-tab :to="{name:'ReturnedChecksToConfirm'}">
                Em Confirmação
                <v-icon :large="$route.name == 'ReturnedChecksToConfirm'" color="amber">mdi-currency-usd</v-icon>
              </v-tab>
              <v-tab :to="{name: 'ReturnedChecksInHands'}">
                Em Mãos
                <v-icon :large="$route.name == 'ReturnedChecksInHands'" color="info">mdi-account-cash-outline</v-icon>
              </v-tab>
              <v-tab :to="{name: 'ReturnedChecksConcluded'}">
                Concluídos
                <v-icon :large="$route.name == 'ReturnedChecksConcluded'" color="light-green">mdi-check-all</v-icon>
              </v-tab>
            </v-tabs>
            <router-view @doneFilter="handleDoneFilter"></router-view>
          </v-card-text>
        </v-card>
      </template>
    </index-card>
  </div>
</template>

<script>
export default {
  name: 'ReturnedChecks',
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    DialogNewReturned: () => import('./DialogNewReturned.vue'),
    BtnCreateDataExport: () => import("@/components/data_export/BtnCreateDataExport.vue"),
  },
  provide() {
    const vm = this
    return {
      registerReturnedChecksListReload(fn) {
        vm.returnedChecksListReload = fn
      },
    }
  },
  data(){
    return{
      filters:{},
      returnedChecksListReload: null,
    }
  },
  methods: {
    handleDoneFilter(filter){
      this.filters = {...filter}
    },
    onHeaderRefreshReturnedChecks() {
      if (this.returnedChecksListReload) this.returnedChecksListReload()
    },
  },
  computed: {
    can_create(){
      return this.isDirector()
    },
  },
}
</script>
